import React from 'react';
import styles from '../../utils/styles/components/AnalyticsHeatmap/style.module.css';

export const AnalyticsHeatmap = ({ note, title }) => {
  return (
    <div className={styles.shell}>
      <div className={styles.copy}>
        <span className={styles.kicker}>Heatmap Overlay</span>
        <h3 className={styles.title}>{title}</h3>
        {note ? <p className={styles.note}>{note}</p> : null}
      </div>

      <button
        className={styles.openButton}
        onClick={() => { window.location.hash = '/analytics/heatmap'; }}
        type="button"
      >
        Voir le heatmap du site
      </button>
    </div>
  );
};
